var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "column is-3 is-2-desktop is-hidden-touch" },
    [
      _c("div", { staticClass: "card sticky-column" }, [
        _c("div", { staticClass: "card-content" }, [
          _c("div", { staticClass: "pt-2 pb-4" }, [
            _c(
              "div",
              {
                staticClass: "has-text-centered is-size-3 has-text-weight-bold",
              },
              [
                _c("i", { staticClass: "fas fa-receipt" }),
                _vm._v(
                  " " + _vm._s(_vm.selectedDocuments.length) + "\n        "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "subtitle is-5 has-text-centered" }, [
            _vm._v(
              " Documento" +
                _vm._s(_vm.selectedDocuments.length > 1 ? "s" : "") +
                " seleccionado" +
                _vm._s(_vm.selectedDocuments.length > 1 ? "s" : "")
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("hr", { staticClass: "m-0" }),
        _vm._v(" "),
        _c("div", { staticClass: "card-content has-text-centered" }, [
          _c("ul", [
            _c("li", { staticClass: "my-2" }, [
              _c(
                "a",
                {
                  staticClass: "has-text-info",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("download")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fas fa-download fa-fw" }),
                  _vm._v(" Descargar\n          "),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "my-2" }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-footer" }, [
          _c(
            "a",
            {
              staticClass: "has-text-dark card-footer-item",
              on: {
                click: function ($event) {
                  return _vm.unselect()
                },
              },
            },
            [
              _c("i", { staticClass: "fas fa-times-circle fa-fw" }),
              _vm._v(" Limpiar\n      "),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }